import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=147ae99e"
import script from "./switcher.vue?vue&type=script&lang=ts"
export * from "./switcher.vue?vue&type=script&lang=ts"
import style0 from "./switcher.vue?vue&type=style&index=0&id=147ae99e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports